export const actionTypes = {
    setPolitic: "SET_POLITIC",
    getPolitics: "GET_POLITICS",
};
